import {combineReducers} from "redux";
import ajouterAssignementUtilisateurCategorieReducer from "./ajouterAssignementUtilisateurCategorie";
import supprimerAssignementUtilisateurCategorieReducer from "./supprimerAssignementUtilisateurCategorie";


export default combineReducers({
    ajouterAssignementUtilisateurCategorie : ajouterAssignementUtilisateurCategorieReducer,
    supprimerAssignementUtilisateurCategorie: supprimerAssignementUtilisateurCategorieReducer
});